
import { GraphElement } from "../graph-element.js"
import { createFromJSON } from "./help"
import Konva from "konva"

class RectElement extends GraphElement {
  static fromJSON = createFromJSON(this)

  constructor(topology, x, y, attrs) {
    super(topology, "rect", x, y, {
      text: "矩形",
      port: true,
      ...attrs
    })
    // 底座加载完成时调用
    this.onLoad(() => {
      // 不需要显示名称
      this.label.visible(false)
    })
  }

  addTransformer() {
    const { storage, editor } = this.__topology

    if (!editor) return

    let tr = this.layer.findOne('#base-el-tr')
    if (!tr) {
      tr = new Konva.Transformer({
        rotateEnabled: false,
        padding: 5,
        ignoreStroke: true,
        id: 'base-el-tr'
      })
      this.layer.add(tr)
    }
    this.keyShape.on('click', () => {
      storage.select(this)
      tr.nodes([this.keyShape])
      this.layer.draw()
    })
    this.stage.on('click', (event) => {
      if (event.target === this.stage) {
        tr.nodes([])
        storage.deselect()
      }
    })

    // 变换时保持端口的相对位置
    this.keyShape.on('transform', () => {
      this.updatePortPosition()
    })

  }

  updatePortPosition() {
    let x = this.keyShape.x()
    let y = this.keyShape.y()
    let w = this.keyShape.width() * this.keyShape.scaleX()
    let h = this.keyShape.height() * this.keyShape.scaleY()
    this.ports.update(x, y, w, h)
  }


  addKeyShape(name, attrs) {
    this.keyShape = this._createDarthNode()
    this.g.add(this.keyShape)

    setTimeout(() => {
      this.executeLoadedHook(this.keyShape)
    })
  }

  _createDarthNode() {
    return new Konva.Rect({
      width: 40,
      height: 20,
      fill: "rgba(0,0,0,0)",
      stroke: "#2CD563",
      // 在变换时不会缩放边框
      strokeScaleEnabled: false,
      x: 0,
      y: 0
    })
  }

}

export { RectElement }
